<template>
    <div>
         <v-container class="pa-5"  >
            <h1 class="display-3 pa-5 indigo darken-1 white--text rounded-tl-xl" > Configurações</h1>

        <v-form  v-model="valid" >
            <v-row>
                <v-col cols="12" >
                    <v-text-field type="text" v-mask="'(##)#####-####'" :rules="inputRules" label="Whastapp da barbearia" v-model="config.telefoneContato" prepend-icon="mdi-cellphone-android" ></v-text-field>
                    <v-text-field type="text" :rules="inputRules" label="Email da barbearia" v-model="config.emailContato" prepend-icon="mdi-email-open" ></v-text-field>
                    
                    <!-- <v-select prepend-icon="mdi-clock"
                    v-model="config.listaHorarios"
                    :items="horas"
                    attach
                    chips
                    label="Exibição minutos"
                    multiple> </v-select> -->

                    <v-text-field prepend-icon="mdi-clock" type="number"  v-model="config.listaHorarios" label="Exibir horário de minutos em minutos:" ></v-text-field>

                         <v-textarea
                        outlined
                        name="input-7-4"
                        label="História da barbearia"
                        :rules="inputRules"
                        v-model="config.textoHistoria"
                        prepend-icon="mdi-format-align-justify"
                        ></v-textarea>
                </v-col>

                <v-col cols="12">
                    <v-btn class="success" @click="atualizarInformacoes" block >Salvar</v-btn>
                    
                </v-col>
            </v-row>


        </v-form>





         </v-container>

         
    </div>
</template>

<script>
import {refConfiguracoes} from '@/firebaseConfig'
    export default {
        data(){
            return{
                valid: true,
                config: {
                    telefoneContato: '',
                    emailContato: '',
                    textoHistoria: '',
                    id: '',
                    listaHorarios: []
                    // telefoneContato: '',
                },
                horas: ["00", "10", "20", "30", "40", "50"],
                inputRules: [
                v => !!v || 'Este campo é obrigatório',
                v => (v && v.length >= 3) || 'Nome precisa ter pelo menos 3 caracteres',],
                emailRules: [
                    v => !!v || 'E-mail é obrigatório',
                    v => /.+@.+\..+/.test(v) || 'E-mail precisa ser válido',
                ],
            }
        },
        created(){
            this.carregarInformacoes()
        },
        methods: {
            carregarInformacoes(){
                refConfiguracoes.get().then(ref => {
                    console.log(ref);
                    this.config = ref.docs[0].data()
                });
            },
            atualizarInformacoes(){
                if(this.config.id === ''){
                    refConfiguracoes.add(this.config).then(ref=>{
                        ref.update({id: ref.id});
                        // console.log("adicionado");
                this.$toasted.success("Adicionado com sucesso!");

                    });
                }else{
                    refConfiguracoes.doc(this.config.id).update(this.config).then(ref=>{
                        console.log(ref);
                                this.$toasted.success("Atualizado com sucesso!");

                    });
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>